import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { ASSETS } from "./assets";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-20 lg:py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid h-10 w-10 place-items-center bg-white rounded-sm overflow-hidden">
                <img src={ASSETS.logo} alt="Logo Sapeur-360 KRX" className="h-full w-full object-contain p-0.5" />
              </span>
              <span className="font-display text-xl font-extrabold tracking-tight">
                Sapeur<span className="text-[#E63946]">-360</span>
              </span>
            </div>
            <p className="mt-5 text-white/60 max-w-sm leading-relaxed">
              La plateforme robotisée sur chenilles qui soulève, déplace et sécurise tout type de
              véhicule — jusqu'à 3 000 kg. Une innovation KRX.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/60">
              <a href="mailto:contact@sapeur-360.fr" className="flex items-center gap-2.5 hover:text-white transition-colors"><Mail className="h-4 w-4 text-[#E63946]" /> contact@sapeur-360.fr</a>
              <a href="tel:+33780179467" className="flex items-center gap-2.5 hover:text-white transition-colors"><Phone className="h-4 w-4 text-[#E63946]" /> +33 (0)7 80 17 94 67</a>
              <span className="flex items-start gap-2.5"><MapPin className="h-4 w-4 text-[#E63946] mt-0.5 shrink-0" /> <span><strong className="text-white/80 font-semibold">Safetyrok SAS</strong><br />38 rue François Chénieux<br />87000 Limoges, France<br /><span className="font-mono-tech text-xs text-white/40">SIRET 981 951 460 00014</span></span></span>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <FooterCol title="Produit" links={["Le produit", "Cas d'usage", "Caractéristiques", "Acquisition"]} />
            <FooterCol title="Secteurs" links={[
              { label: "Sapeurs-pompiers", to: "/sapeurs-pompiers" },
              { label: "Fourrière & dépannage", to: "/fourriere-depannage" },
              { label: "Garages & concessions", to: "/garages-concessions" },
              { label: "Logistique industrielle", to: "/logistique-industrielle" },
            ]} />
            <FooterCol title="Société" links={[
              { label: "À propos KRX", to: "/#produit" },
              { label: "Documentation", to: "/#specs" },
              { label: "Contact", to: "/contact" },
            ]} />
          </div>
        </div>

        <div className="mt-16 font-display text-6xl sm:text-8xl lg:text-9xl font-black tracking-tighter text-white/5 select-none">
          SAPEUR-360
        </div>

        <div className="mt-8 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-white/40">
          <span>© {new Date().getFullYear()} Safetyrok SAS — Sapeur-360 by KRX. Tous droits réservés.</span>
          <div className="flex gap-6">
            <a href="#contact" className="hover:text-white transition-colors">Mentions légales</a>
            <a href="#contact" className="hover:text-white transition-colors">Confidentialité</a>
            <a href="#contact" className="hover:text-white transition-colors">CGV</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#A1A1AA] mb-4">{title}</h4>
      <ul className="space-y-2.5">
        {links.map((l) => {
          const item = typeof l === "string" ? { label: l } : l;
          return (
            <li key={item.label}>
              {item.to ? (
                <Link to={item.to} className="text-sm text-white/70 hover:text-white transition-colors">{item.label}</Link>
              ) : (
                <a href="#contact" className="text-sm text-white/70 hover:text-white transition-colors">{item.label}</a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
